export default {"src":"/_next/static/media/leftScrollArrow.51c58fd5.svg","height":22,"width":13,"blurWidth":0,"blurHeight":0};